/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
// import Image from 'next/image';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import styles from '../contentPage.module.scss';
import NextSeoWrapper from '@/components/NextSeoWrapper';
import PageContainer from '@/components/PageContainer';
import { getLanguageAlternates } from '@/utils/locale';
import { getCanonicalUrl } from '@/utils/navigation';

const path = '/quran-foundation';
const quranFoundation = () => {
    const { t, lang } = useTranslation('quran-foundation');
    const members = [
        { sr: 1, name: "Abdul Rauf", designation: "Chairman", occupation: "Retired Army Officer" },
        { sr: 2, name: "Munir Ahmad", designation: "Vice Chairman", occupation: "Business" },
        { sr: 3, name: "Aftab Ahmad", designation: "General Secretary", occupation: "Retired Army Officer" },
        { sr: 4, name: "Sidra Ali", designation: "Joint secretary", occupation: "Private Job" },
        { sr: 5, name: "Muhammad Iqbal", designation: "Finance Secretary", occupation: "Private Job" },
        { sr: 6, name: "Syed Ubaid ur Rahman", designation: "Chief Organizer", occupation: "Private Job" },
        { sr: 7, name: "Ghulam Mohiuddin", designation: "Information Secretary", occupation: "Business" },
    ];

    return (
        <>
            <NextSeoWrapper
                title="quran-foundation"
                url={getCanonicalUrl(lang, path)}
                languageAlternates={getLanguageAlternates(path)}
            />
            <PageContainer>
                <div className={styles.historyPage}>
                    <h1 style={{ textAlign: 'center' }}>{t('quran-foundation:founder')}</h1>
                    <p style={{ textAlign: 'center', fontWeight: 'bold' }} className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:founder-txt"
                        />
                    </p>

                    <h1 style={{ textAlign: 'center' }}>{t('quran-foundation:aim-and-obj')}</h1>
                    {Array.from({ length: 7 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`quran-foundation:aim-and-obj-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1 style={{ textAlign: 'center' }}>{t('quran-foundation:ofc-ber')}</h1>
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>Sr No</th>
                                    <th>Name</th>
                                    <th>Designation</th>
                                    <th>Occupation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {members.map((member) => (
                                    <tr key={member.sr}>
                                        <td>{member.sr}</td>
                                        <td>{member.name}</td>
                                        <td>{member.designation}</td>
                                        <td>{member.occupation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <h1 style={{ textAlign: 'center' }}>{t('quran-foundation:powe-and-duties')}</h1>
                    <h1 >{t('quran-foundation:chairman')}</h1>
                    {Array.from({ length: 7 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`quran-foundation:chairman-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1>{t('quran-foundation:vice-chairman')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:vice-chairman-txt"
                        />
                    </p>
                    <h1 >{t('quran-foundation:general-sec')}</h1>
                    {Array.from({ length: 7 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`quran-foundation:general-sec-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1>{t('quran-foundation:joint-sec')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:joint-sec-txt"
                        />
                    </p>
                    <h1 >{t('quran-foundation:finance-sec')}</h1>
                    {Array.from({ length: 5 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`quran-foundation:finance-sec-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1>{t('quran-foundation:chief-org')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:chief-org-txt"
                        />
                    </p>
                    <h1>{t('quran-foundation:info-sec')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:info-sec-txt"
                        />
                    </p>
                    <h1>{t('quran-foundation:member')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:member-txt"
                        />
                    </p>
                    <h1 style={{ textAlign: "center" }}>{t('quran-foundation:rule-and-regulation')}</h1>
                    <h1>{t('quran-foundation:memberShip')}</h1>
                    {Array.from({ length: 3 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`quran-foundation:memberShip-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1>{t('quran-foundation:disqualification')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:disqualification-txt"
                        />
                    </p>
                    {Array.from({ length: 6 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`quran-foundation:disqualification-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1>{t('quran-foundation:source-inc')}</h1>
                    {Array.from({ length: 2 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`quran-foundation:source-inc-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1>{t('quran-foundation:bank-acc')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:bank-acc-txt-1"
                        />
                    </p>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:bank-acc-txt-2"
                        />
                    </p>
                    {Array.from({ length: 2 }, (_, i) => (
                        <p key={i} className={styles.lineHeigh}>
                            <Trans i18nKey={`quran-foundation:bank-acc-opt-txt-${i + 1}`} />
                        </p>
                    ))}
                    <h1>{t('quran-foundation:meeting')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:meeting-txt"
                        />
                    </p>
                    <h1>{t('quran-foundation:post-meeting')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:post-meeting-txt"
                        />
                    </p>
                    <h1>{t('quran-foundation:audit')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:audit-txt"
                        />
                    </p>
                    <h1>{t('quran-foundation:quorum')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:quorum-txt"
                        />
                    </p>
                    <h1>{t('quran-foundation:amendment')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:amendment-txt"
                        />
                    </p>
                    <h1>{t('quran-foundation:dissolution')}</h1>
                    <p className={styles.lineHeigh}>
                        <Trans
                            i18nKey="quran-foundation:dissolution-txt"
                        />
                    </p>
                </div>
            </PageContainer>
        </>
    );
};

export default quranFoundation;
